/*
* 注册handlebar全局helpers
*
* */
define(function (require) {
    var Handlebars = require('handlebars');
    var compareHelpers = {

        /**
         * Or
         * Conditionally render a block if one of the values is truthy.
         */
        or: function (a, b, options) {
            if (a || b) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        },

        // 获取数组第一个元素
        getFirstElement: function(arr, orgId) {
            if (typeof arr === 'object') {
                return location.protocol + '//'+ location.host +'/@context.name@/s?func=lp:getImg&img_id='+ arr[0] +'&org_id=' + orgId;
            } else {
                return arr;
            }
        },
        // 判断数组是否为空
        isArrayNotNull: function(a, options) {
            if (typeof a === 'object' && a.length !== 0) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        }
    };

    // register helpers
    for (var helper in compareHelpers) {
        if (compareHelpers.hasOwnProperty(helper)) {
            Handlebars.registerHelper(helper, compareHelpers[helper]);
        }
    }

    return Handlebars;
});



/*****************
 ** WEBPACK FOOTER
 ** ./web.modules/coremail.framework/src/common/assets/index_cmxt50/js/hbshelper.js
 ** module id = 99
 ** module chunks = 15
 **/